meedy.factory('meedy.calendarService', ['$q', '$translate', '$http', 'meedy.baseService', 'meedy.objectHelper', 'meedyConfig',
    function ($q, $translate, $http, baseService, objectHelper, config) {

        function CalendarService() {
            this.getCalendarDataForResource = function (resourceId, startDate, calendarType) {
                var request = {
                    resourceId: resourceId,
                    startDate: objectHelper.convertDatesToTimes(startDate),
                    calendarType: calendarType
                };

                return baseService.post(config.API_URL + '/calendars/getCalendarData', request).then(
                    function (successResponse) {
                        var data = successResponse;
                      //   data[1543964400000].availabilities={
                      //     830127: [{ startTime: 1544024700000, endTime:1544025600000}],
                      //
                      //       830243:[{ startTime: 1544024700000, endTime:1544025600000}]
                      // };
                      //   data[1544050800000].availabilities={};
                        _.forOwn(data, function(value, key) {
                            _.forOwn(data[key].availabilities, function(availaibilityValue, availaibilityKey) {
                                data[key].availabilities[availaibilityKey] = objectHelper.translateArray(availaibilityValue, AvailabilityRuleOccurrenceMeedyVO);
                                data[key].availabilities[availaibilityKey] = objectHelper.convertTimesToDates(data[key].availabilities[availaibilityKey]);
                            });
                            _.forOwn(data[key].terms, function(termsValue, termsKey) {
                                data[key].terms[termsKey] = objectHelper.translateArray(termsValue, TermMeedyVO);
                                data[key].terms[termsKey] = objectHelper.convertTimesToDates(data[key].terms[termsKey]);
                            });
                        });
                        
                        return $q.resolve(data);
                    },
                    function (errorResponse) {
                        return $q.reject(errorResponse);
                    }
                );
            };

            this.getCalendarData = function(requestParams) {
                var _requestParams = objectHelper.convertDatesToTimes(requestParams);
                return baseService.post(config.API_URL + '/calendars/getCalendarData', _requestParams).then(
                    function(successResponse) {
                        var data = successResponse;

                        _.forOwn(data, function(value, key) {
                            _.forOwn(data[key].availabilities, function(availaibilityValue, availaibilityKey) {
                                data[key].availabilities[availaibilityKey] = objectHelper.translateArray(availaibilityValue, AvailabilityRuleOccurrenceMeedyVO);
                                data[key].availabilities[availaibilityKey] = objectHelper.convertTimesToDates(data[key].availabilities[availaibilityKey]);
                            });
                            _.forOwn(data[key].terms, function(termsValue, termsKey) {
                                data[key].terms[termsKey] = objectHelper.translateArray(termsValue, TermMeedyVO);
                                data[key].terms[termsKey] = objectHelper.convertTimesToDates(data[key].terms[termsKey]);
                            });
                        });
                      
                        return $q.resolve(data);
                    },
                    function(errorResponse) {
                        return $q.reject(errorResponse);
                    }
                );
            };

            this.getDailyPlanToken = function (object) {
                var d = $q.defer();

                baseService.post(config.API_URL + '/calendars/dailyPlan/token', object).then(
                    function (token) {
                        d.resolve(token);
                    },
                    function (errorResponse) {
                        d.reject(errorResponse);
                    }
                );

                return d.promise;
            };

            this.downloadDailyPlan = function (token) {
                var d = $q.defer();

                $http({
                    url :  config.API_URL + '/calendars/dailyPlan/download/' + token,
                    method : 'GET',
                    params : {},
                    headers : {
                        'Content-type' : 'application/pdf'
                    },
                    responseType : 'arraybuffer'
                }).success(function(data, status, headers, config) {
                    var file = new Blob([ data ], {
                            type : 'application/pdf'
                        });

                    var fileURL = URL.createObjectURL(file);
                    var a         = document.createElement('a');
                    a.href        = fileURL;
                    a.target      = '_blank';
                    a.download    = 'Plan Dnia';

                    document.body.appendChild(a);
                    a.click();

                    d.resolve(data);
                }).error(function(data, status, headers, config) {
                    d.reject(data);
                });

                return d.promise;
            };

            this.searchMeedyPatients = function(requestParams) {
                var _requestParams = objectHelper.convertDatesToTimes(requestParams);
                return baseService.post(config.API_URL + '/patients/getPatients', _requestParams).then(
                    function(successResponse) {
                        var data = successResponse.data;
                        data = objectHelper.translateArray(data, PatientMeedyVO);
                        // data = objectHelper.convertTimesToDates(data);

                        return $q.resolve(data);
                    },
                    function(errorResponse) {
                        return $q.reject(errorResponse);
                    }
                );
            };
        }

        return new CalendarService();
    }
]);
